//
//
//
//
//
//
//
//

  import Vue from 'vue'

export default {
  name: 'App',
}



// WEBPACK FOOTER //
// ./src/App.vue